<template>
    <div class="main-wrappers">
      <b-tabs 
        id="tabs-test" 
        lazy 
        content-class="mt-3"
        :value="currentActiveTabIndex"
        @input="handleTabChange"
        no-fade
      >                  
        <b-tab title="Public Apps">
          <AMR v-if="currentActiveTab === 'apps'"/>
        </b-tab>
        <b-tab title="Private Apps">
          <AMR v-if="currentActiveTab === 'privateApps'"/>
        </b-tab> 
        <b-tab title="Custom JS">
          <Dashboard v-if="currentActiveTab === 'customjs'"/>
        </b-tab>   
        <b-tab title="App Reviews">
          <AppReviews v-if="currentActiveTab === 'reviews'"/>
        </b-tab>                                
      </b-tabs>        
    </div>
</template>
<script>
import AppsDashboard from "@/components/marketplace/marketplaceAppsReviewPortal/AppsDashboard.vue";
import Dashboard from "@/components/marketplace/marketplaceAppsReviewPortal/customJsReviewPortal/Dashboard.vue";
import AppReviews from "@/components/marketplace/marketplaceAppsReviewPortal/appRatingReviews/AppReviews.vue";
import AMR from "@/components/marketplace/components/AppReview.vue"
export default {
    components:{AppsDashboard, Dashboard, AppReviews, AMR},
    data(){
      return{
        tabMapping: ['apps', 'privateApps', 'customjs', 'reviews'],
        isChangingTab: false
      }
    },
    computed: {
      currentActiveTab() {
        return this.$route.query.t || "apps"
      },
      currentActiveTabIndex() {
        return this.tabMapping.indexOf(this.currentActiveTab)
      }
    },
    methods: {
      async handleTabChange(newTabIndex) {
        // Prevent Bootstrap from changing tabs while we update the route
        if (this.isChangingTab) return
        
        const newTab = this.tabMapping[newTabIndex]
        
        // Don't update if it's already the current tab
        if (newTab === this.currentActiveTab) return
        
        this.isChangingTab = true
        
        try {
          // Update route first - this will trigger the UI change
          await this.$router.replace({
            name: this.$route.name,
            query: {
              ...this.$route.query,
              t: newTab
            }
          })
        } catch (error) {
          console.error('Failed to change tab:', error)
        } finally {
          this.isChangingTab = false
        }
      }
    },
    mounted(){
      // If no query param exists, set it immediately to default tab
      if (!this.$route.query.t) {
        this.$router.replace({
          name: this.$route.name,
          query: { t: "apps" }
        })
      }
    },
  };
</script>
